.fixedHeaderTop {
  position: sticky;
  top: 60px;
  z-index: 4;

  transition: all 0.5s;
  // COUPLING: 50px feeds the fly-out sidebar's visible-height calc in
  // libs/webui/util/src/RouteOffCanvas/RouteOffCanvas.module.scss — raise this value and that
  // calc must rise with it.
  // `min-height` (not `height`) so the box grows to actually contain its content — title +
  // description + breadcrumbs can exceed 50px. A fixed `height: 50px` clipped the box while
  // overflow:visible content kept painting past it.
  min-height: 50px;
  // This box's static (unstuck) position must already sit at `top: 60px` in normal flow for the
  // sticky offset to be a no-op — every app pairing `FixedPage.Header` with a fixed top navbar
  // clears that navbar with its own `#main { margin-top: 60px }` rule (e.g.
  // `apps/panelpunches/admin/src/assets/css/style.css`), which pushes this header down to y=60
  // before it ever sticks. Adding compensation here (e.g. a matching `margin-bottom`) would
  // double that offset — see `FixedPageHeader.tsx` for the `RouteOffCanvas` `top: 0` case, which
  // has no navbar and needs no such margin either.
  background-color: var(--bs-body-bg);
}

.fixedBody {
  margin-top: 0px;
  // This class, not the document, is the page's scroll region — the sticky rules on the title
  // band and on any tab bar resolve against it. Only what Bootstrap cannot express lives here:
  // the zero minimum that lets the column shrink and the single-axis scroll.
  min-height: 0;
  overflow-y: auto;
}
